import { render } from "./ColorDetail.vue?vue&type=template&id=f8596f54"
import script from "./ColorDetail.vue?vue&type=script&lang=js"
export * from "./ColorDetail.vue?vue&type=script&lang=js"

import "./ColorDetail.vue?vue&type=style&index=0&id=f8596f54&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__